module.exports = __webpack_public_path__ + "media/bootstrap-icons/bookmark-plus-fill-10e03a3c.svg";